import { useState } from 'react'
import Box from '@mui/material/Box'
import Button from '@mui/material/Button'
import EmailRoundedIcon from '@mui/icons-material/EmailRounded'
import Alert from '@mui/material/Alert'
import Dialog from '@mui/material/Dialog'
import DialogContent from '@mui/material/DialogContent'
import CircularProgress from '@mui/material/CircularProgress'
import Typography from '@mui/material/Typography'
import CheckCircleRoundedIcon from '@mui/icons-material/CheckCircleRounded'

import type { User } from '@/types'
import { useSendUserWelcomeEmail } from '@/hooks/api/use-users'

function SendUserWelcomeEmail({
    user,
}: {
    user: User,
}) {

    const [requestInProgress, setRequestInProgress] = useState(false)
    const [error, setError] = useState<string | null>(null)
    const [success, setSuccess] = useState(false)
    const [confirmation, setConfirmation] = useState(false)

    const toggleActiveMutation = useSendUserWelcomeEmail(user.id, {
        onSuccessCallback(data) {
            if(data) {
                setSuccess(true)
            }
        },
        onErrorCallback(errorMessage) {
            setError(errorMessage)
        },
        setRequestInProgress,
    })

    const handleSendEmail = () => {
        toggleActiveMutation.mutate()
        setConfirmation(false)
    }

    return (
        <Box mt={1}>
            {success &&
                <Alert
                    severity="success"
                    sx={(theme) => ({
                        flexGrow: 1,
                        margin: theme.spacing(1, 0),
                    })}
                    onClose={() => setSuccess(false)}
                >
                    Email úspěšně odeslán.
                </Alert>
            }
            {error &&
                <Alert
                    severity="error"
                    sx={(theme) => ({
                        flexGrow: 1,
                        margin: theme.spacing(1, 0),
                    })}
                    onClose={() => setError(null)}
                >
                    {error}
                </Alert>
            }
            {!success && !error &&
                <Button
                    startIcon={<EmailRoundedIcon />}
                    onClick={() => setConfirmation(true)}
                    color='terciary'
                    variant="outlined"
                    disabled={requestInProgress}
                >
                    Odeslat přístupový email
                </Button>
            }
            <Dialog
                key={'user-'+user?.id}
                open={confirmation}
                onClose={() => setConfirmation(false)}
            >
                <DialogContent>
                     <Box sx={{
                        display: 'flex',
                        flexDirection: 'column',
                        justifyContent: 'center',
                        alignItems: 'center',
                    }}>
                        <Typography variant="h5" component="div" mb={2}>
                            Potvrďte prosím odeslání
                        </Typography>
                        <Typography variant="body2" component="div" mb={2}>
                            Tato akce odešle uživateli přístupový email s nově vygenerovaným heslem. Pokud se jedná o existujícího uživatele, heslo se mu tím změní!
                        </Typography>
                        <Box sx={{
                            display: 'flex',
                            justifyContent: 'center',
                            flexGrow: 1,
                        }}>
                            <Button
                                variant="text"
                                color="terciary"
                                onClick={() => setConfirmation(false)}
                            >
                                Zrušit
                            </Button>
                            <Button
                                variant="contained"
                                color="success"
                                startIcon={requestInProgress ? <CircularProgress color="inherit" size={20} /> : <CheckCircleRoundedIcon />}
                                onClick={() => handleSendEmail()}
                                disabled={requestInProgress}
                            >
                                Odeslat
                            </Button>
                        </Box>
                    </Box>
                </DialogContent>
            </Dialog>
        </Box>
    )
}

export default SendUserWelcomeEmail
